"use client";
import { useState, useEffect } from "react";

export const useAccordion = () => {
  const [activeItem, setActiveItem] = useState(0);

  useEffect(() => {
    setActiveItem(0);
  }, []);

  const toggleOpen = (id: number) => () =>
    setActiveItem((activeItem) => (activeItem === id ? null : id));

  return {
    toggleOpen,
    activeItem,
    setActiveItem,
  };
};
